import { render, staticRenderFns } from "./InstituteEditForm.vue?vue&type=template&id=f6c263fe&"
import script from "./InstituteEditForm.vue?vue&type=script&lang=js&"
export * from "./InstituteEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports